<template>
  <vue-modal :active="active" container-class="bg-white" @closed="$emit('closed')">
    <report-orders type="labels" per-page="16" class="report-orders-labels">
      <template slot-scope="{report}">
        <div class="report-page break-after-always flex flex-wrap content-start justify-center mx-auto my-0" v-for="(page, index) in report" :key="index">
          <report-orders-label v-for="(entry, index) in page" :key="index" :entry="entry"/>
        </div>
      </template>
    </report-orders>
  </vue-modal>
</template>

<script>
import modal from '../../mixins/modal';
import ReportOrders from './ReportOrders.vue';
import ReportOrdersLabel from '../reports/ReportOrdersLabel.vue';

export default {
  mixins: [modal],

  components: { ReportOrders, ReportOrdersLabel },
};
</script>

<style lang="scss" scoped>
.report-page {
  max-width: 210mm;
}

@media print {
  .report-page {
    max-width: none;
    padding: 7mm 0;
    margin: 0;
    justify-content: flex-start;
  }
}
</style>
